import { useEffect, useState } from "react"

import { fetchOthers } from "lib/film-fetcher"
import { useCountry } from "lib/country"

import { Others as FilmOthers } from "components/film"

export const Others = ({ product }) => {
	const { country } = useCountry()

	const [isLoading, setIsLoading] = useState(true)
	const [others, setOthers] = useState()

	useEffect(
		() => {
			if (product === undefined || product.id === 9999999) {
				return
			}

			const init = async () => {
				setIsLoading(true)
				setOthers(await fetchOthers(product.id, country.isoCode))
				setIsLoading(false)
			}

			init()
		},
		[product, country]
	)

	return (
		<FilmOthers
			product={product}
			loading={isLoading}
			others={others}
			isSvod
		/>
	)
}
